"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var SkypeToast_1 = require("./SkypeToast");
var WarningToast_1 = require("./WarningToast");
var NotificationViewState_1 = require("../store/schema/NotificationViewState");
var mobx_react_1 = require("mobx-react");
var React = require("react");
var NotificationToast = /** @class */ (function (_super) {
    tslib_1.__extends(NotificationToast, _super);
    function NotificationToast() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NotificationToast.prototype.render = function () {
        var notification = this.props.notification;
        switch (notification.actionType) {
            case NotificationViewState_1.NotificationActionType.SkypeNotification:
                return React.createElement(SkypeToast_1.default, { notification: notification });
            default:
                return React.createElement(WarningToast_1.default, { notification: notification });
        }
    };
    NotificationToast = tslib_1.__decorate([
        mobx_react_1.observer
    ], NotificationToast);
    return NotificationToast;
}(React.Component));
exports.default = NotificationToast;
//# sourceMappingURL=NotificationToast.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/controls/owa-header-toast-notification/lib/components/NotificationToast.js
// module id = 1615
// module chunks = 3 14 105 106 107